import SvgIcon from '@mui/material/SvgIcon';

/**
 * ThumbnailNavigationRightIcon ~
*/
export default function ThumbnailNavigationRightIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M0,0H24V24H0Z" transform="translate(24) rotate(90)" fill="none" />
        <path d="M3,3H21V5H3Z" transform="translate(24) rotate(90)" />
        <path d="M19,3H5V21H19ZM17,19H7V5H17Z" transform="translate(-2)" />
      </svg>
    </SvgIcon>
  );
}
